/* eslint-disable new-cap */
import AWS from 'aws-sdk';

const s3 = new AWS.S3({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});
const bucketBaseURL = process.env.REACT_APP_AWS_BUCKET_URL;

export { bucketBaseURL };
export default s3;
